// The PDF filed to the EMR. Consents, policies and ABNs are filed in the
// language the patient used (the legal record); every other form in English,
// so clinical staff can read it. The PDF header prints the language used.
// The patient page (src/forms/patient/emrPdf.js) applies the same rule.
export const LEGAL_RECORD_CATEGORIES = ["consent", "policy", "abn"];

export function emrPdfLang(def, lang) {
  return LEGAL_RECORD_CATEGORIES.includes(def && def.category) ? lang : "en";
}

// Renders the EMR PDF in the browser with the Step 1 renderer (dynamic import:
// react-pdf stays out of this module's static graph).
export async function renderEmrPdf(def, response, prefill) {
  const { buildFormPdfBlob } = await import("../pdf/formPdf");
  return buildFormPdfBlob({
    definition: def,
    response,
    prefill: prefill || {},
    lang: emrPdfLang(def, response && response.lang),
  });
}
